import React, { useState, useEffect } from 'react'
import axiosClient from '../../front/axiosClient';
import { Link, useParams } from 'react-router-dom';
import BackButton from '../../front/components/BackButton';
import { useAuth } from '../../Context/AuthUser';
import Popup from '../../components/Popup';

function ManageShop() {
    const {user} = useAuth();
    const {id} = useParams();
    const [duration, setDuration] = useState();
    const [dateFrom, setDateFrom] = useState();
    const [dateTo, setDateTo] = useState('');
    const [errors, setErrors] = useState({});
    const [alert, setAlert] = useState(null);
    const [openTime, setOpenTime] = useState();
    const [closeTime, setCloseTime] = useState();
    const [openPeriod, setOpenPeriod] = useState("AM");
    const [closePeriod, setClosePeriod] = useState("PM");

    const validator = () => {
        const errors = {};
        if (!duration) errors.duration = 'Duration is required!';
        if (!dateFrom) errors.dateFrom = 'From date is required!';
        return errors;
    }

    useEffect(() => {
        getShopBarber();
    }, []);

    const getShopBarber = async () =>{
        const { data } = await axiosClient.get(`/barber/shop-barbers.php?action=edit&id=${id}`)
        if (data.status === 'success') {
            var barber = data.data
          
        } else {
            setAlert({ type: "error", message: data.data.message });
        }
    } 

    const handleSubmit = async (e) =>{
        e.preventDefault(); // add this
        const openHour = openTime ? `${openTime} ${openPeriod}` : null;
        const closeHour = closeTime ? `${closeTime} ${closePeriod}` : null;
        const validateErrors = validator();
        setErrors(validateErrors);
        const { data } = await axiosClient.post(`/barber/manage-shop.php`,
            { duration, dateFrom, dateTo, openHour, closeHour},
            { headers: { "Content-Type": "application/json" } }
        )
        if (data.status === 'success') {
            setAlert({ type: "success", message: data.message });
        } else {
            setAlert({ type: "error", message: data.message });
        }
    }
    return (
        <div>
            {alert && (
                <Popup type={alert.type} message={alert.message} />
            )}
            <div className='page-header'>
                <Link to="" style={{ fontSize: '20px', color: 'gray' }}><BackButton /></Link>
                <div className='heder'>
                    <h4 style={{ fontSize: '16px', fontWeight: '600' }}>Manage Shop</h4>
                    <p className="subtitle">Manage your shop timing and holiday's (close).</p>
                </div>
            </div>
            <div className='row'>
                <div className='col-12'>
                    <div className='card'>
                        <h4 className='page-heading'> Add Shop Holiday</h4>
                        <div className='card-body'>
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-4">
                                        <div className="group-input">
                                            <label>Duration <span style={{color: 'red'}}>*</span></label>
                                            <select value={duration} onChange={(e) => setDuration(e.target.value)}>
                                                <option value="">Select Duration</option>
                                                <option value="full">Full Day</option>
                                                <option value="half">Half Day</option>
                                            </select>
                                            {errors.duration && <span style={{ color: "red", fontSize: "14px", }}>{errors.duration}</span>}
                                        </div>
                                    </div>
                                   
                                    <div className="col-4">
                                        <div className="group-input">
                                            <label>Date From <span style={{color: 'red'}}>*</span></label>
                                            <input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} placeholder="Enter date from" />
                                            {errors.dateFrom && <span style={{ color: "red", fontSize: "14px", }}>{errors.dateFrom}</span>}
                                        </div>
                                    </div>

                                    <div className="col-4">
                                        <div className="group-input">
                                            <label>Date To (Use, If shop close for more than 1 day)</label>
                                            <input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} placeholder="Enter shop barber dateTo" />
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="group-input">
                                            <label>Open Time (Use, If shop close for half day)</label>
                                            <div style={{ display: "flex", gap: "10px" }}>
                                                <select value={openTime} onChange={(e) => setOpenTime(e.target.value)}>
                                                    <option value="">Hour</option>
                                                    {[...Array(12)].map((_, i) => (
                                                        <option key={i + 1} value={i + 1}>
                                                            {i + 1}
                                                        </option>
                                                    ))}
                                                </select>

                                                <select value={openPeriod} onChange={(e) => setOpenPeriod(e.target.value)}>
                                                    <option value="AM">AM</option>
                                                    <option value="PM">PM</option>
                                                </select>
                                            </div>
                                            {errors.openTime && <span style={{ color: "red", fontSize: "14px" }}>{errors.openTime}</span>}
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="group-input">
                                            <label>Close Time (Use, If shop close for half day)</label>
                                            <div style={{ display: "flex", gap: "10px" }}>
                                                <select value={closeTime} onChange={(e) => setCloseTime(e.target.value)}>
                                                    <option value="">Hour</option>
                                                    {[...Array(12)].map((_, i) => (
                                                        <option key={i + 1} value={i + 1}>
                                                            {i + 1}
                                                        </option>
                                                    ))}
                                                </select>

                                                <select value={closePeriod} onChange={(e) => setClosePeriod(e.target.value)}>
                                                    <option value="AM">AM</option>
                                                    <option value="PM">PM</option>
                                                </select>
                                            </div>

                                            {errors.closeTime && <span style={{ color: "red", fontSize: "14px" }}>{errors.closeTime}</span>}
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div className="group-input">
                                            <button type="submit" className="submit-btn">Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ManageShop
